import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { currentTheme, setTheme } from '../lib/theme';

/** Переключатель «Светлая тема»: выключен — тёмная (по умолчанию), включён — светлая. */
export function ThemeToggle() {
  const { t } = useTranslation();
  const [light, setLight] = useState(() => currentTheme() === 'light');
  return (
    <button
      type="button"
      role="switch"
      aria-checked={light}
      className="theme-switch"
      onClick={() => {
        const next = !light;
        setTheme(next ? 'light' : 'dark');
        setLight(next);
      }}
    >
      <span className="track" aria-hidden="true">
        <span className="thumb" />
      </span>
      {t('nav.lightTheme')}
    </button>
  );
}
